
import { defineComponent, PropType } from "vue";

interface Props {
  variant:
    | "tiny"
    | "xSmall"
    | "small"
    | "medium"
    | "large"
    | "xLarge"
    | "xxLarge"
    | "mega";
  weight: number | string;
}

const __default__ = defineComponent({
  props: {
    variant: {
      type: String as PropType<
        | "tiny"
        | "xSmall"
        | "small"
        | "medium"
        | "large"
        | "xLarge"
        | "xxLarge"
        | "mega"
      >,
      required: false,
      default: "medium",
      validator: (value) =>
        "string" === typeof value &&
        [
          "tiny",
          "xSmall",
          "small",
          "medium",
          "large",
          "xLarge",
          "xxLarge",
          "mega",
        ].includes(value),
    },
    weight: {
      type: [Number, String] as PropType<number | string>,
      default: 400,
      validator: (value) =>
        ("number" === typeof value || "string" === typeof value) &&
        [
          "100",
          "200",
          "300",
          "400",
          "500",
          "600",
          "700",
          "800",
          "900",
        ].includes(`${value}`),
    },
  },
  setup(props: Props) {
    return {
      weight: props.weight,
    };
  },
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "4322c8e8": (_ctx.weight)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__